module.exports = __webpack_public_path__ + "images/FUSA_icons/075-package-2.4136939458c63d29da5f8e6eea5affa3.svg";